import { createTheme, ThemeProvider } from "@mui/material/styles";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const getTheme = (mode = "dark") =>
  createTheme({
    palette: {
      mode,
      background: {
        default: mode === "light" ? "#f7faff" : "#0e1520",
        paper: mode === "light" ? "#ffffff" : "#182133",
      },
    },
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: ({ theme }) => ({
            /* všechny řádky – sudé / liché */
            "& .MuiDataGrid-row:nth-of-type(even)": {
              backgroundColor:
                theme.palette.mode === "dark"
                  ? theme.palette.background.paper // tma
                  : "#ffffff", // světlá
            },
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor:
                theme.palette.mode === "dark"
                  ? theme.palette.background.default // ještě tmavší
                  : "#ebeef0", // šedá
            },
          }),
        },
      },
    },
  });

const ColorModeContext = createContext({
  mode: "light",
  toggleMode: () => {},
});
export const useColorMode = () => useContext(ColorModeContext);
/* ------------------------------------------------------------------ */

export default function ThemeProviderEx({ children }) {
  const [mode, setMode] = useState(() => {
    const saved = window.localStorage.getItem("mui-theme-mode");
    return saved ? saved : "dark";
  });

  useEffect(() => {
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = () => setMode(mql.matches ? "dark" : "light");
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleMode: () =>
        setMode((prev) => {
          const next = prev === "light" ? "dark" : "light";
          window.localStorage.setItem("mui-theme-mode", next);
          return next;
        }),
    }),
    [mode]
  );

  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}> {children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
}
